import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { ConfirmModalShell } from '../work-queue/tasks/approval-review/ConfirmModalShell';
import { ConfirmModalHeader } from '../work-queue/tasks/approval-review/ConfirmModalHeader';
import { ConfirmModalFooter } from '../work-queue/tasks/approval-review/ConfirmModalFooter';

interface VirtualAppointmentMarkDoneModalProps {
    typeTitle: string;
    submitting: boolean;
    /** The API's refusal, shown above the buttons. */
    apiError: string | null;
    onConfirm: () => void;
    onClose: () => void;
}

export function VirtualAppointmentMarkDoneModal({
    typeTitle,
    submitting,
    apiError,
    onConfirm,
    onClose
}: VirtualAppointmentMarkDoneModalProps) {
    return (
        <ConfirmModalShell widthClassName="w-[420px]" dismissible={!submitting} onDismiss={onClose}>
            <ConfirmModalHeader
                icon={CheckCircleIcon}
                iconClassName="w-5 h-5 text-green-600"
                title="Mark as done"
                onClose={onClose}
                disabled={submitting}
            />
            <div className="px-5 py-4 flex flex-col gap-3">
                <p className="text-sm text-gray-800 font-semibold break-words">{typeTitle}</p>
                <p className="text-sm text-gray-600">Mark this VA as done?</p>
                {apiError && (
                    <p
                        role="alert"
                        className="text-sm text-red-800 bg-red-50 border border-red-300 rounded-md px-3 py-2"
                    >
                        {apiError}
                    </p>
                )}
            </div>
            <ConfirmModalFooter
                onCancel={onClose}
                onConfirm={onConfirm}
                cancelLabel="Keep open"
                cancelDisabled={submitting}
                confirmDisabled={submitting}
                confirmLabel={submitting ? 'Marking…' : 'Mark as done'}
                confirmColorClassName="bg-green-600 text-white hover:bg-green-700"
            />
        </ConfirmModalShell>
    );
}
